'use strict';

var centralApp = angular.module('app.services');

// Serviço de notificação
centralApp.factory('notificacao', notificacaoSrv);

notificacaoSrv.$inject = ['$alert', '$notification', '$window'];
function notificacaoSrv($alert, $notification, $window) {

    return {

        driver: 'toastr',

        opcoes: {},

        duracao: 5,

        /**
        * Exibe mensagens fomatadas na visão de erro. 
        * As mensagens são disparadas pelo domínio da 
        * aplicação através de serviços RESTful.
        * 
        * @param object response
        */
        erroResponse: function (response) {
            if (response.status === 500) {
                this.com('toastr').erro('Erro', 'Ocorreu um erro, tente novamente');
            } else {
                _.each(_.get(response, 'data.errors', []),function (error) {
                    this.erro(error.key, error.value)
                }.bind(this))
            }
        },

        /**
         * Fornece um meio para selecionar
         * qual drive será responsável por 
         * dispara a notificação
         */
        com: function (driver, callback) {
            this.driver = driver || this.driver;

            return this;
        },

        /**
         * Informa quanto tempo a notificação deve
         * ficar ativa
         */
        durante: function (segundados) {
            this.duracao = segundados;

            return this;
        },

        /**
         * Notificação de sucesso
         */
        sucesso: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo, 
                mensagem: mensagem,
                tipo: 'success',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de alerta
         */
        alerta: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'warning',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de alerta
         */
        aviso: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'warning',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de informação
         */
        info: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'info',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de erro
         */
        erro: function (titulo, mensagem, opcoes) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                tipo: 'error',
                opcoes: opcoes
            });
        },

        /**
         * Notificação de negado
         */
        negado: function (titulo, mensagem, opcoes) {
            this.erro(titulo, mensagem, opcoes);
        },

        /**
         * Dispara notificação
         * 
         * Exemplo: Notificacao.notificar({
         *      titulo: 'Importante',
         *      mensagem: 'Verifique suas atualizações',
         *      tipo: 'alerta',
         *      driver: 'desktop'
         * });
         */
        notificar:  function(notificacao){

            if (_.isUndefined(notificacao.mensagem)) {
                notificacao.mensagem = notificacao.titulo;

                notificacao.titulo = '';
            }

            // Normaliza algumas propriedades
            notificacao.tipo    = _.get(notificacao, 'tipo', 'warning');
            notificacao.driver  = _.get(notificacao, 'driver', this.driver);
            notificacao.opcoes  = _.get(notificacao, 'opcoes', this.opcoes);

            switch (notificacao.tipo ){
                case 'info': 
                     notificacao.duracao = 10;
                    break;
                case 'success':
                     notificacao.duracao = 5;
                    break;
                case 'warning': 
                     notificacao.duracao = 10;
                    break;
                case 'error':
                case 'danger':
                     notificacao.duracao = 15;
                    break;
                default :
                     notificacao.duracao = 3;
            }

            var driver = this.normalizarDriver(notificacao.driver);

            try {

                // Dispara notificação
                this[driver](notificacao);

            } catch(e){

                console.error('Houve um erro ao construir o driver de notificação!', e);

            }

            // Reseta driver
            this.driver = 'toastr';

        },

        /**
         * Dispara notificação
         * 
         * @param string titulo
         * @param string mensagem
         * @param string driver
         */
        disparar: function (titulo, mensagem, driver) {
            this.notificar({
                titulo: titulo,
                mensagem: mensagem,
                driver: driver
            });
        },

        /**
         * Normaliza o nome do driver para ser criado
         * 
         * @param string driver
         */
        normalizarDriver: function(driver){
            return 'criar' + _.capitalize(driver) + 'Driver';
        },

        /**
         * Cria o dirver strap de notificação
         */
        criarStrapDriver: function (notificacao) {
            
            $alert(_.merge({
                title: notificacao.titulo,
                type: notificacao.tipo,
                content: notificacao.mensagem,
                duration: notificacao.duracao,
                animation: 'am-fade-and-slide-top',
                placement: 'top-right',
                show: true
            }, notificacao.opcoes));

        },

        /**
         * Cria o dirver toastr de notificação
         */
        criarToastrDriver: function (notificacao) {

            notificacao.opcoes = {
                closeButton: true,
                debug: false,
                newestOnTop: true,
                progressBar: true,
                positionClass: "toast-top-center",
                preventDuplicates: true,
                showDuration: "300",
                hideDuration: "1000",
                extendedTimeOut: "1000",
                showEasing: "swing",
                hideEasing: "linear",
                showMethod: "fadeIn",
                hideMethod: "fadeOut",
                timeOut: (notificacao.duracao || 5) * 1000
            };

            toastr[notificacao.tipo](
                notificacao.mensagem, 
                notificacao.titulo, 
                notificacao.opcoes
            );

        },

        /**
         * Cria o dirver desktop de notificação
         */
        criarDesktopDriver: function (notificacao) {

            var self = this;

            $notification.requestPermission().then(function (permissao) {

                if (permissao === 'granted') {
                    $notification(notificacao.titulo, {
                        body: notificacao.mensagem,
                        focusWindowOnClick: true,
                        delay: notificacao.duracao * 1000,
                        icon: notificacao.imagem || require('assets/img/perfil.png'),
                        tag: _.kebabCase(notificacao.mensagem)
                    });
                } else if (permissao === 'denied') {
                    self.sucesso(notificacao.titulo, notificacao.mensagem, 'toastr');
                }

            })

        }

    }
}


//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/services/notificacao-service.js
// module id = 328
// module chunks = 1